export const environment = {
  version: "1.0.0",
  production: false,

  // LOCAL

  baseUrl: "http://localhost:90",
  loginUrl: "http://localhost:90",
  cors: "http://localhost:90",

  // TEST

  //baseUrl: 'http://indianmhs.nimhans.ac.in:9091/dmhp-api',
  //loginUrl: 'http://indianmhs.nimhans.ac.in:9091/dmhp-api',
  //cors: 'http://indianmhs.nimhans.ac.in:9091/dmhp-api',

  // LIVE

  // baseUrl: 'http://indianmhs.nimhans.ac.in:90/dmhp-api',
  // loginUrl: 'http://indianmhs.nimhans.ac.in:90/dmhp-api',
  // cors: 'http://indianmhs.nimhans.ac.in:90/dmhp-api'
};

import "zone.js/dist/zone-error"; // Included with Angular CLI.
